export default "<div class='visualItem'>\n  <img [src]='imageSrc' />\n</div>\n"